import React from 'react'
import { Flex, Input, Button, Text } from '../../Components'
import { useCQuery } from '../../Services/QueryCache'
import { FC } from '../../Services/FeathersClient'
import { JsonExample } from '../Documents/Draggable/Functions'

export const Test = () => {
  const [file, setFile] = React.useState(null)
  const { data: environments = [] } = useCQuery(['environments'])
  const [selectedSociety, setSelectedSociety] = React.useState(null)
  const [loading, setLoading] = React.useState(false)

  const testCall = async () => {
    if (!file) {
      window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Seleziona un file' })
      return
    }
    if (!selectedSociety) {
      window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Seleziona una società' })
      return
    }
    setLoading(true)
    try {
      const response = await FC.service('compileForm').create({
        file,
        data: JsonExample,
        type: 'compile',
        codSociety: selectedSociety,
        environment: 'OUTS'
      })
      if (response.error) {
        window.growl.show({ severity: 'error', summary: 'Errore', detail: response.error })
      } else if (response.byteLength) {
        window.growl.show({ severity: 'success', summary: 'Successo', detail: 'Documento generato correttamente' })
        const blob = new Blob([response], { type: 'application/pdf' })
        const url = URL.createObjectURL(blob)
        window.open(url, '_blank')
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Flex fw>
      <Text value='Test Compilazione Documento' size={22} bold style={{ marginBottom: 20 }} />
      <Flex fw row>
        <input type='file' onChange={(e) => setFile(e.target.files[0])} />
        <Input
          dropdown id='environment' style={{ width: 300, marginLeft: 10 }}
          options={environments.map(env => ({ label: env.name, value: env.codSociety }))}
          placeholder='Società'
          value={selectedSociety}
          onChange={({ environment }) => setSelectedSociety(environment)}
        />
        <Button onClick={testCall} label='Test' icon='fa-duotone fa-rocket' style={{ marginLeft: 10 }} spinner={loading} />
      </Flex>
    </Flex>
  )
}
